<template>
  <div class="sl-favicon-uploader-wrapper">
    <span class="mr-8"
      >{{ $t("message.storeLocator.basic.favoritesIcon") }}:</span
    >
    <div class="sl-favicon-uploader">
      <input ref="input" type="file" class="d-none" @change="setFile" />
      <template v-if="localSrc">
        <div class="sl-favicon-uploader__preview">
          <img :src="localSrc" alt="logo preview" />
        </div>
      </template>
      <div v-else class="sl-favicon-uploader__preview">
        <img src="@/static/store-locator/favicon.svg" />
      </div>
    </div>
    <ui-button
      class="sl-favicon-uploader-wrapper__btn"
      shadow
      color="light"
      text-color="dark"
      @click="selectFile"
      >{{ $t("message.common.change") }}</ui-button
    >
  </div>
</template>

<script>
export default {
  name: "StoreLocatorConfigFaviconUploader",
  props: {
    faviconSrc: {
      type: String
    }
  },
  data: () => ({
    file: null,
    imgSrc: null
  }),
  computed: {
    localSrc() {
      return this.imgSrc || this.faviconSrc;
    }
  },
  methods: {
    setFile(event) {
      this.file = this.getSelectedFile(event);
      this.resetStateIfNoFile();

      if (!this.isValidImageFile(this.file)) {
        return;
      }

      this.readFile(this.file);
    },

    getSelectedFile(event) {
      return event.target.files.length ? event.target.files[0] : null;
    },

    resetStateIfNoFile() {
      if (!this.file) {
        this.imgSrc = null;
        this.onChange(null);
      }
    },

    isValidImageFile(file) {
      return file && file.type.includes("image/");
    },

    readFile(file) {
      if (typeof FileReader !== "function") {
        alert("Sorry, FileReader API not supported");
        return;
      }

      const reader = new FileReader();
      reader.onload = event => {
        this.imgSrc = event.target.result;
        this.onChange(file);
      };
      reader.readAsDataURL(file);
    },
    selectFile() {
      this.$refs.input.click();
    },
    onChange(file) {
      this.$emit("change", file);
    }
  }
};
</script>

<style lang="scss" scoped>
.sl-favicon-uploader-wrapper {
  display: flex;
  align-items: center;
  @include font-size(14px);
  color: $dark-blue-3;

  &__btn {
    width: 130px;
  }
}

.sl-favicon-uploader {
  width: 48px;
  height: 48px;
  background: $light-4;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  position: relative;
  margin-right: 32px;

  &__preview {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $light;
    overflow: hidden;

    img {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
